const isExternal = (url: string) => url.startsWith("http") || url.startsWith("mailto");

export default isExternal;
